import React, { useState } from "react";
import "./ConfirmDialog.css";

export default function ConfirmDialog({
  open,
  title = "Confirm Action",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  variant = "primary",
  onConfirm,
  onCancel,
  alternateLabel,
  alternateVariant = "outline",
  onAlternate,
}) {
  const [working, setWorking] = useState(false);
  if (!open) return null;

  const handleConfirm = async () => {
    if (!onConfirm) return;
    try {
      setWorking(true);
      await onConfirm();
    } finally {
      setWorking(false);
    }
  };

  const handleAlternate = async () => {
    if (!onAlternate) return;
    try {
      setWorking(true);
      await onAlternate();
    } finally {
      setWorking(false);
    }
  };

  const handleCancel = () => {
    if (working) return;
    onCancel?.();
  };

  return (
    <div className="confirm-modal">
      <div className="confirm-modal__content">
        <div className="confirm-modal__header">
          <h6>{title}</h6>
          <button type="button" className="icon-btn" onClick={handleCancel} aria-label="Close dialog">
            <i className="bi bi-x-lg" />
          </button>
        </div>
        <div className="confirm-modal__body">
          {typeof message === "string" ? <p>{message}</p> : message}
        </div>
        <div className="confirm-modal__actions">
          {alternateLabel && (
            <button
              type="button"
              className={`pf-btn ${
                alternateVariant === "danger"
                  ? "pf-btn-danger"
                  : alternateVariant === "primary"
                  ? "pf-btn-primary"
                  : "pf-btn-outline"
              }`}
              onClick={handleAlternate}
              disabled={working}
            >
              {alternateLabel}
            </button>
          )}
          <button type="button" className="pf-btn pf-btn-outline" onClick={handleCancel} disabled={working}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`pf-btn ${variant === "danger" ? "pf-btn-danger" : "pf-btn-primary"}`}
            onClick={handleConfirm}
            disabled={working}
          >
            {working ? "Please wait..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
